import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Avatar, Icon } from 'rhinostyle';
import HtmlMessage from '../HtmlMessage';
import { DateHelpers, UserHelpers } from '../../helpers';
import { getLoggedInUser } from '../../selectors/userSelectors';

const { formatAvatarName } = UserHelpers;

const ScheduledMessageEvent = (props) => {
  const { event } = props;
  const {
    fromUser = {},
    timestamp,
    formattedFromUserName,
    formattedTimestamp,
    scheduledAt,
  } = event;

  const profileImageUrl = fromUser?.profileImageUrl
    ? `${process.env.REACT_APP_AVATAR_BASE_URL || ''}${fromUser.profileImageUrl}`
    : '';

  const scheduledLabel = scheduledAt
    ? `Scheduled for ${DateHelpers.formatTimestamp(scheduledAt)}`
    : 'Scheduled';

  return (
    <div>
      <div className="convo__item__header">{formattedFromUserName || '  '}</div>
      <div className="convo__item__body">
        <div className="convo__item__body__avatar">
          <Avatar
            image={profileImageUrl}
            name={formatAvatarName(fromUser?.firstName, fromUser?.lastName)}
            size="small"
            type="member"
            className="avatar-blue"
          />
        </div>
        <div>
          <HtmlMessage event={event} />
        </div>
      </div>
      <div className="convo__item__footer">
        <div className="convo__item__footer__message">
          <Icon icon="clock" />&nbsp;
          <span className="u-text-muted u-text-small">{scheduledLabel}</span>
          &nbsp;&nbsp;
          <span title={DateHelpers.fullTimestamp(timestamp)}>{formattedTimestamp}</span>
        </div>
      </div>
    </div>
  );
};

ScheduledMessageEvent.propTypes = {
  event: PropTypes.object,
};

const mapStateToProps = (state) => ({
  currentUser: getLoggedInUser(state),
});

export default connect(mapStateToProps)(ScheduledMessageEvent);
